"use client"
import type { LegalContent } from "@/lib/legal"
import { ScrollReveal } from "@/components/scroll/ScrollReveal"
import { Footer } from "@/components/layout/Footer"
import { LegalNav } from "@/components/legal/LegalNav"

const BG = "#0B0F1C"
const ACCENT = "#C4541A"
const MUTED = "rgba(255,255,255,0.6)"
const BORDER = "rgba(255,255,255,0.08)"

const H2Style = { fontSize: 18, fontWeight: 700, letterSpacing: "-0.02em", marginBottom: 12, color: "#fff" }
const BodyStyle = { color: MUTED, fontSize: 15, lineHeight: 1.75, whiteSpace: "pre-line" as const }
const SectionStyle = { borderBottom: `1px solid ${BORDER}`, paddingBottom: 32 }


export function PrivacyClient({ content }: { content: LegalContent }) {
  return (
    <main style={{ background: BG, color: "#fff", minHeight: "100vh" }}>
      <section style={{ padding: "clamp(100px, 14vw, 140px) clamp(20px, 4vw, 48px) clamp(60px, 8vw, 100px)", maxWidth: 860, margin: "0 auto" }}>
        <ScrollReveal effect="fade-up">
          <div style={{ display: "flex", gap: 16, alignItems: "center", marginBottom: 32 }}>
            <span style={{ width: 32, height: 1, background: ACCENT, flexShrink: 0 }} />
            <span style={{ fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", color: MUTED }}>Legal</span>
          </div>
          <h1 style={{ fontSize: "clamp(36px, 6vw, 80px)", fontWeight: 900, letterSpacing: "-0.04em", lineHeight: 0.9, marginBottom: 16 }}>{content.headingLine1}<br /><span style={{ color: ACCENT }}>{content.headingLine2}</span>
          </h1>
          <p style={{ color: MUTED, fontSize: 13, marginBottom: 8, opacity: 0.6 }}>{content.urlLine}</p>
          <p style={{ color: MUTED, fontSize: 14, marginBottom: 16 }}>{content.datesLine}</p>
          <p style={{ color: MUTED, fontSize: 14, marginBottom: 48, lineHeight: 1.65 }}>{content.intro}</p>
          <LegalNav />
        </ScrollReveal>

        <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
          {content.sections.map(section => (
            <ScrollReveal key={section.title} effect="fade-up">
              <div style={SectionStyle}>
                <h2 style={H2Style}>{section.title}</h2>
                <p style={BodyStyle}>{section.body}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </section>
      <Footer />
    </main>
  )
}
